<template>
    <b-modal
    v-model="openModal"
    :title="title"
    header-bg-variant="dark"
    header-text-variant="light"
    no-close-on-backdrop
    no-close-on-esc
    hide-header-close
    >
    <div class="text-center my-3">{{message}}</div>
    <template v-slot:modal-footer>
        <b-button size="sm" variant="danger" @click.prevent="$emit('close-modal')">
                Cancelar
        </b-button>
        <b-button size="sm" variant="success" @click.prevent="$emit('confirm-modal')">
                Confirmar
        </b-button>
    </template>
    </b-modal>
</template>

<script>
export default {
    name: "ModalConfirm",
    props: {
        message: {
            type: String,
            default: ''
        },
        title: {
            type: String,
            default: ''
        },
        openModal: {
            type: Boolean,
            default: false
        }
    }

};

</script>
